import { Bubble, NameBanner } from '@rumblefish/ui/Rumblefish23Theme';

import { BenefitsData } from './Benefits.data';
import {
  StyledStack,
  BubbleWrapper,
  StyledSection,
  StyledHeadline,
  SingleBenefitWrapper,
  StyledBenefitHeadline,
  StyledBenefitsWrapper,
  SectionNameBannerStack,
  StyledBenefitDescription,
} from './styles';

export const Benefits = ({ ...props }) => {
  const benefits = BenefitsData();

  return (
    <StyledSection width="normal">
      <StyledStack {...props}>
        <SectionNameBannerStack>
          <NameBanner type="section" text="Benefits" color="raspberry" />
        </SectionNameBannerStack>
        <StyledHeadline
          display={{ xs: 'none', md: 'block' }}
          variant="display_md"
          paragraph>
          Benefits of choosing
          <br /> Rumble Fish as your
          <br /> fintech product
          <br /> development company
        </StyledHeadline>
        <StyledHeadline
          display={{ xs: 'block', md: 'none' }}
          variant="display_md"
          paragraph>
          Benefits of choosing Rumble Fish as your fintech product development
          company
        </StyledHeadline>

        <StyledBenefitsWrapper>
          {benefits.map((el, index) => (
            <SingleBenefitWrapper key={index}>
              <BubbleWrapper>
                <Bubble
                  params={{
                    name: `benefits_${el.name}`,
                    icon: el.icon,
                    gradientColor: el.gradientColor,
                    top: 0,
                    left: 0,
                    size: 100,
                    boxShadow: el.boxShadow,
                    floatingY: el.floatingY,
                    duration: el.duration,
                  }}
                />
              </BubbleWrapper>
              <StyledBenefitHeadline variant="strong_500">
                {el.title}
              </StyledBenefitHeadline>

              <StyledBenefitDescription variant="regular_400">
                {el.description}
              </StyledBenefitDescription>
            </SingleBenefitWrapper>
          ))}
        </StyledBenefitsWrapper>
      </StyledStack>
    </StyledSection>
  );
};
